module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vwassets/new2/_next/static/images/foilGlitterySilver-917addbdc1adc9967e7adebecde9c976.svg";